define([
    'text!fnjihome2021-detail/component/main.html',
    'common/api',
    'jquery',
    'common/utils',
    'fnjihome2021-detail/component/swiper-project',

    'css!web/common/css/common.css'
], function(
    tpl,Api,$,Utils,
    SwiperProject
){
    return {
        template: tpl,
        data: function(){
            return {
                fnjiHome: [],
                isZh: true,
                isPC: true,

                homeDetailImg: [],
                homeDetailPhoneImg: []
            };
        },
        components: {
            SwiperProject: SwiperProject
        },
        computed: {

        },
        created: function () {
            var obj = this;


        },
        methods: {
            getPC: function() {
                var _this = this;
                if($(window).width()<=750){
                    _this.isPC = false;
                    $('.fixed-menu').css({'display': 'none'});
                }else {
                    _this.isPC = true;
                }
                if(_this.$i18n.locale=='en'){
                    _this.isZh = false;
                }else {
                    _this.isZh = true;
                }
            },
            init: function () {
                var obj = this;
                Api.getFnjiHome.ajax({id: Utils.getUrlKey("id")})
                    .done(function (data) {
                        obj.fnjiHome = data.data;
                        obj.homeDetailImg = obj.fnjiHome.footImg.split(';');
                        console.log(obj.homeDetailImg);
                        obj.homeDetailPhoneImg = obj.fnjiHome.footImgM.split(';');
                        obj.$nextTick(function(){
                            obj.initMasonry();
                        });
                        Utils.emitPageReady();
                    });
            },
            initMasonry:function () {

            }
        },
        watch: {
            '$i18n.locale': function () {
                this.init();
            }
        },
        mounted: function(){
            this.getPC();
            this.init();
            var obj = this;
            $(window).resize( function  () {           //当浏览器大小变化时
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                }
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./fnjihome2021-detail/component/main.js
// module id = 148
// module chunks = 1